import React, { useContext } from 'react'
import { LocalizationContext } from '../shared/contexts'
import { formatTenantDateTime } from '../../utils/formatTenantDateTime'
import { Box, Typography } from '@mui/material'
import { FullTimeline, NA, TimelineRow } from './shared/Timeline'
import { TIME_SOURCE } from '../../utils/timeSource'

export interface QueuedOrderSummary {
  id: number
  recipe_name: string | null
  state: string
  marked_for_disposal: boolean
  disposal_reason: string | null
  disposed_at: string | null
  timeline: FullTimeline
}

export interface OrderShowOrder {
  id: number
  number: string | null
  external_id: string | null
  tracking_url: string | null
  infor_metadata_present: boolean
  infor_metadata_fetched_at: string | null
  ordered_at: string | null
  last_delivered_at: string | null
  order_provider: { provider_type: string } | null
  customer: { id: number; phone_number: string } | null
  queued_orders: QueuedOrderSummary[]
}

const OrderShowHeader = ({ order }: { order: OrderShowOrder }) => {
  const localization = useContext(LocalizationContext)
  const fmt = (value: string | null) => formatTenantDateTime(value, localization)

  const providerLabel = order.order_provider
    ? `${order.order_provider.provider_type.charAt(0)}${order.order_provider.provider_type.slice(1).toLowerCase()} external ID`
    : null

  return (
    <Box className='order-show-header'>
      <div className='order-show-header-top'>
        <Typography variant='h4'>
          Order #{order.number || order.id}
        </Typography>
        <div className='order-show-header-actions'>
          <a href='/orders?tab=1' className='btn btn-link'>← Back to orders</a>
          {order.tracking_url &&
            <a href={order.tracking_url} target='_blank' rel='noopener noreferrer' className='btn btn-sm bw-button ms-2 me-3'>
              Tracking page
            </a>
          }
        </div>
      </div>

      {(providerLabel || order.customer?.phone_number) &&
        <div className='order-show-summary'>
          {providerLabel &&
            <div className='order-show-summary-item'>
              <span className='label'>{providerLabel}</span>
              <span className='value'>{order.external_id || NA}</span>
            </div>
          }
          {order.customer?.phone_number &&
            <div className='order-show-summary-item'>
              <span className='label'>Customer phone</span>
              <span className='value'>{order.customer.phone_number}</span>
            </div>
          }
        </div>
      }

      <Box className='order-show-timeline'>
        <TimelineRow label='Ordered at' value={fmt(order.ordered_at)} offsetSeconds={null} source={TIME_SOURCE.app} />
        <TimelineRow label='Last item picked up' value={fmt(order.last_delivered_at)} offsetSeconds={null} source={TIME_SOURCE.app} />
      </Box>
    </Box>
  )
}

export default OrderShowHeader
